import { Unishop } from './unishop.js';
import { AdminService } from './main/AdminService.js';
import { GlobalErrorHandler } from './main/GlobalErrorHandler.js';
import { SessionStorageService } from './main/SessionStorageService.js';

//*****
// START Export all used classes (we need to export anything that is used in our Razor views)
//*****

export { Cookies } from './main/Cookies.js'; // Master.cshtml, StdPageLayout.cshtml, ProductCategory.cshtml
export { ModalPopup } from './main/ModalPopup.js'; // StdPageLayout.cshtml
export {
  Login, // Partials/Forms/Login.cshtml
  LookupOrder, // Partials/Forms/LookupOrder.cshtml
  RegisterUser, // Partials/Forms/RegisterUser.cshtml
} from './main/LoginRegistration.js';
export { WarrantyFormViewModel } from './business/WarrantyForm.js'; // Partials\blockgrid\Components\warrantyAndReturnsForm.cshtml
export { SubmitMeasurementsFormViewModel } from './business/SubmitMeasurementsForm.js'; // Partials\blockgrid\Components\submitMeasurementsForm.cshtml
export { LinkBusinessMdlService } from './business/LinkBusinessMdlService.js'; // Partials\blockgrid\Components\retailersSearchBlock.cshtml
export { RetailerSearch } from './business/RetailerSearch.js'; // Partials\blockgrid\Components\retailersSearchBlock.cshtml
export { StartDesignerViewModel } from './designer-app/StartDesignerViewModel.js'; // Partials\blockgrid\Components\startDesignerActionBlockNew.cshtml

//*****
// END Export all used classes
//*****

/*
 * This class should be instantiated from our master view (i.e. Master.cshtml), and should contain
 * js code which must be run on every page.
 */
export class App {
  constructor(config) {
    this.adminService = new AdminService(config.adminServiceUrl);
    // Install global error handler:
    this.globalErrorHandler = new GlobalErrorHandler(this.adminService);
    this.sessionStorageService = new SessionStorageService();

    /* The Unishop class sets up a DOMContentLoaded event handler which will execute its setup method
     * This method is over 600 lines long, is heavily dependent on jQuery, and will set up DOM event
     * handlers and more. We use the options object to optimize wheach Unishop features to use on
     * every page. The values below are the default ones. Pages which need a different set of features
     * should modify the window.langloStoreApp.unishop.options object before the DOMContentLoaded event
     * is raised. */
    const options = {
      /* If true, then the NavBar (and our logo) will always be visible. Note, this also requires the
       * navbar-sticky class to be set on the navbar header element inside MenuBar.cshtml. */
      useStickyNavBar: false,
      /* If an anchor tag has the scroll-to class, then the useSmoothScrollToElement option will enable
       * a smooth scroll to the target element. If not set, then a quick scroll will happen instead.
       * As of 9/23/2021 this feature is only used on home-/landing-/meetus-pages with image sliders
       * where the down-arrow button is enabled. Hence, the useSmoothScrollToElement option should be
       * set on these kinds of pages. */
      useSmoothScrollToElement: false,
      useIsotopeGrid: false, // Used on the product category page
      usePhotoSwiper: false, // Used on home pages, the product page, etc
      useProductImageCarousel: false, // Used on the product page
      vendorDelayedWaiter: config.vendorDelayedWaiter, // Allow Unishop to wait for the vendor delayed script to load
    };
    this.unishop = new Unishop(options);

    this.cachBusterTest = 5; // Just for testing our cache buster code. Increment value as needed.
  }
}
